import { endpoints, baseurl } from "../Utils/Constants";

export const checkEmail = async (email) => {
  try {
    const response = await fetch(baseurl + endpoints.CHECKEMAIL + email,{
      method: "GET",
      cache: "no-store",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    }).then(
      (res) => res.json()
    );

    return response;
  } catch (error) {
    console.error("Error checking email:", error);
    throw error;
  }
};

export const login = async (data) => {
  try {
    const response = await fetch(baseurl + endpoints.LOGIN, {
      method: "POST",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());

    return response;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
}

export const sendOtp = async (email) => {
  try {
    const response = await fetch(baseurl + endpoints.SEND_OTP + email, {
      method: "GET",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    }).then((res) => res.json());

    return response;
  } catch (error) {
    console.error("Error sending OTP:", error);
    throw error;
  }
};

export const verifyOtp = async (data) => {
  try {
    const response = await fetch(baseurl + endpoints.VERIFY_OTP, {
      method: "POST",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());

    return response;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await fetch(baseurl + endpoints.FORGOT_PASSWORD + email, {
      method: "GET",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    }).then((res) => res.json());
    return response;
  } catch (error) {
    console.error("Error sending forgot password request:", error);
    throw error;
  }
};

export const checkValidity = async (email, token) => {
  try {
    const query = new URLSearchParams({ email, token }).toString();
    const response = await fetch(`${baseurl + endpoints.CHECKVALIDITY}?${query}`, {
      method: "GET",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    }).then((res) => res.json());
    return response;
  } catch (error) {
    console.error("Error checking link validity:", error);
    throw error;
  }
}

export const updatePassword = async (data) => {
  try{
    const response = await fetch(baseurl + endpoints.UPDATE_PASSWORD, {
      method: "POST",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());

    return response;
  } catch (error) {
    console.error("Error updating password:", error);
    throw error;
  }
}
